// Empty implementation of React


// WEBPACK FOOTER //
// /src/DeveloperTools/FBWrappers/FakeReact.ts


// WEBPACK FOOTER //
// webpack:///src/DeveloperTools/FBWrappers/FakeReact.ts